/**
 * DEV-1443 — Auth identity-switch state flush.
 *
 * On ANY auth identity change (login, email login, registration completing,
 * 2FA verify, impersonate / end-impersonate, logout) this clears ALL per-user
 * client caches so a prior user's state can never render for the next identity
 * on a shared/lab browser:
 *   - the query cache (queryCache.clearAll)
 *   - every in-memory hydration store (store.resetAllStores)
 *
 * Device-level localStorage (theme / language / calendar) is intentionally NOT
 * touched here; per-user localStorage keys are isolated by user_guid
 * namespacing (see DEV-1443 Fix 2). This is an identity event, not an App.tsx
 * cache-handler invalidation, so it does not violate the CLAUDE.md query-cache
 * rule.
 */
import { clearAll as clearQueryCache } from '../api/queryCache';
import { resetAllStores } from '../Data/store';

export function flushClientStateForIdentitySwitch(): void {
  try { clearQueryCache(); } catch { /* noop — flush is best-effort */ }
  try { resetAllStores(); } catch { /* noop */ }
}
